// Generated by CoffeeScript 1.12.4
var opsSites;

require('ng-storage');

opsSites = require('goodeggs-ops-sites');

angular.module(__filename, [require('goodeggs-ops-sites/angular'), 'ngStorage']).config([
  '$httpProvider', function($httpProvider) {
    return $httpProvider.defaults.withCredentials = true;
  }
]).factory('Auth', [
  '$http', '$q', '$location', '$window', '$localStorage', '$timeout', function($http, $q, $location, $window, $localStorage, $timeout) {
    var _login, getLoginUrl, identifyToken, kaleUrl, renewToken;
    kaleUrl = opsSites.getUrl('kale', $window.settings);
    getLoginUrl = function(allowNonEmployees) {
      var redirectUrl;
      if (allowNonEmployees) {
        return kaleUrl + "/#/login";
      }
      redirectUrl = $location.absUrl();
      return kaleUrl + "/auth/token/google?redirect=" + (encodeURIComponent(redirectUrl));
    };

    /*
    Redirect to login with the specified token provider.
    @param {String} provider - app which provides authentication tokens. only 'google' supported right now
     */
    _login = function(loginUrl) {
      var ref;
      if (+$localStorage['authRedirectCount'] > 2) {
        delete $localStorage['authRedirectCount'];
        if ($window != null) {
          if ((ref = $window.Rollbar) != null) {
            ref.error('Authentication redirect loop');
          }
        }
        return $q.reject(new Error("The app seems to be stuck in an authentication redirect loop."));
      }
      if ($localStorage['authRedirectCount'] == null) {
        $localStorage['authRedirectCount'] = 0;
      }
      $localStorage['authRedirectCount']++;
      $window.location.replace(loginUrl);
      return $q.when();
    };

    /*
    Attempt to identify the user's current token.
    - If token does not exist or is not valid, redirect to login.
    - If token successfully identified, also renew it.
    @param {String} provider - app which provides authentication tokens. only 'google' supported right now
    @param {String} tokenIdentifierApp - name of app which identifies the users current token.
     */
    identifyToken = function(provider, tokenIdentifierApp, arg) {
      var allowNonEmployees;
      if (tokenIdentifierApp == null) {
        tokenIdentifierApp = 'opsEmployeesApi';
      }
      allowNonEmployees = arg.allowNonEmployees;
      if (provider !== 'google') {
        return $q.reject(new Error("Login for provider " + provider + " isn't implemented yet."));
      }
      return $http({
        method: 'GET',
        url: "" + (opsSites.getUrl(tokenIdentifierApp, $window.settings)) + (tokenIdentifierApp === 'kale' ? '' : '/v1') + "/auth/token/identify/" + provider,
        withCredentials: true
      }).then(function(response) {
        var credentials, ref;
        delete $localStorage['authRedirectCount'];
        credentials = response.data;
        if (!allowNonEmployees && ((credentials != null ? (ref = credentials.employee) != null ? ref._id : void 0 : void 0) == null)) {
          return $q.reject(new Error('Must be an account known to the Employees app'));
        }
        return renewToken(provider, tokenIdentifierApp, credentials, {
          allowNonEmployees: allowNonEmployees
        })["catch"](function(err) {
          return credentials;
        });
      })["catch"](function(rejection) {
        if (rejection.status !== 401) {
          return $q.reject(rejection);
        }
        return _login(getLoginUrl(allowNonEmployees)).then(function() {
          return $q.reject(new Error('Need to log in'));
        });
      });
    };

    /*
    Attempt to renew current token if necessary.
    - if token not past half-life, do nothing and reject.
    - if token past expiration, redirect to login
    - otherwise request a renewed token from the token provider
    only applies to tokens:
    - with expiration (which should be all tokens!)
    - with an endpoint that supports renewal (only google via kale for now).
    @param {String} provider - app which provides authentication tokens. only 'google' supported right now
    @param {String} tokenIdentifierApp - name of app which identifies the users current token.
    @param {Object} credentials - object containing users current credentials to renew.
    @returns promise that either a) fulfills with renewed credentials, b) rejects (for error or other reason).
     */
    renewToken = function(provider, tokenIdentifierApp, credentials, arg) {
      var allowNonEmployees, currentTime, timeToExpiration, tokenLifespan;
      allowNonEmployees = arg.allowNonEmployees;
      if (provider !== 'google') {
        return $q.reject(new Error("Renewal for provider " + provider + " isn't implemented yet."));
      }
      if (!(((credentials != null ? credentials.iat : void 0) != null) && (credentials.exp != null))) {
        return $q.reject(new Error("Token does not have timestamps, can't renew."));
      }
      currentTime = Math.floor(new Date().valueOf() / 1000);
      tokenLifespan = credentials.exp - credentials.iat;
      timeToExpiration = credentials.exp - currentTime;
      if (timeToExpiration >= (tokenLifespan / 2)) {
        return $q.reject(new Error("Don't need to renew token yet"));
      } else if (timeToExpiration <= 0) {
        return _login(getLoginUrl(allowNonEmployees)).then(function() {
          return $q.reject(new Error('Need to log in'));
        });
      } else {
        return $http({
          method: 'GET',
          url: kaleUrl + "/auth/token/google/renew",
          withCredentials: true
        }).then(function(response) {
          return response.data;
        })["catch"](function(rejection) {
          return $q.reject(rejection);
        });
      }
    };
    return {
      identifyToken: identifyToken,
      renewToken: renewToken
    };
  }
]);

module.exports = __filename;
